import { render, staticRenderFns } from "./warrantson.vue?vue&type=template&id=2e36ce7e&scoped=true&"
import script from "./warrantson.vue?vue&type=script&lang=js&"
export * from "./warrantson.vue?vue&type=script&lang=js&"
import style0 from "./warrantson.vue?vue&type=style&index=0&id=2e36ce7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36ce7e",
  null
  
)

export default component.exports